import { Routes, Route } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { Box, AppBar, Toolbar, Button, Container } from '@mui/material';
import { EmailGatePage } from '@/pages/auth/EmailGatePage';
import { AdminTokenGatePage } from '@/pages/auth/AdminTokenGatePage';
import { CallbackPage } from '@/pages/auth/CallbackPage';
import { RequireAdminAuth } from '@/auth/RequireAdminAuth';
import { AdminShellNavigation } from '@/components/AdminShellNavigation';
import { BusinessesListPage } from '@/pages/businesses/BusinessesListPage';
import { UsersListPage } from '@/pages/users/UsersListPage';
import { ServicesPage } from '@/pages/services/ServicesPage';
import { ProvidersListPage } from '@/pages/providers/ProvidersListPage';
import { AnalyticsPage } from '@/pages/analytics/AnalyticsPage';
import { UserOutreachPage } from '@/pages/outreach/UserOutreachPage';

function DashboardPage() {
  const { logout, user } = useAuth0();

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <AdminShellNavigation />
      <Box sx={{ flex: 1 }}>
        <Container maxWidth="lg">
          <Box sx={{ py: 4 }}>
            <h1>Welcome</h1>
            <p>
              Signed in as: <strong>{user?.email}</strong>
            </p>
            <p>Select a resource from the menu on the left to get started.</p>
            <Button variant="contained" onClick={handleLogout}>
              Logout
            </Button>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}

function AdminLayout({ children }: { children: React.ReactNode }) {
  const { logout } = useAuth0();

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', flexDirection: 'column' }}>
      <AppBar position="static" sx={{ backgroundColor: '#FFFFFF', color: '#1F2933', boxShadow: 1 }}>
        <Toolbar sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            color="inherit"
            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
          >
            Logout
          </Button>
        </Toolbar>
      </AppBar>
      <Box sx={{ display: 'flex', flex: 1 }}>
        <AdminShellNavigation />
        <Box sx={{ flex: 1, overflow: 'auto' }}>{children}</Box>
      </Box>
    </Box>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/callback" element={<CallbackPage />} />
      <Route path="/email-gate" element={<EmailGatePage />} />
      <Route path="/token-gate" element={<AdminTokenGatePage />} />
      <Route
        path="/"
        element={
          <RequireAdminAuth>
            <AdminLayout>
              <DashboardPage />
            </AdminLayout>
          </RequireAdminAuth>
        }
      />
      <Route
        path="/businesses"
        element={
          <RequireAdminAuth>
            <AdminLayout>
              <BusinessesListPage />
            </AdminLayout>
          </RequireAdminAuth>
        }
      />
      <Route
        path="/users"
        element={
          <RequireAdminAuth>
            <AdminLayout>
              <UsersListPage />
            </AdminLayout>
          </RequireAdminAuth>
        }
      />
      <Route
        path="/services"
        element={
          <RequireAdminAuth>
            <AdminLayout>
              <ServicesPage />
            </AdminLayout>
          </RequireAdminAuth>
        }
      />
      <Route
        path="/providers"
        element={
          <RequireAdminAuth>
            <AdminLayout>
              <ProvidersListPage />
            </AdminLayout>
          </RequireAdminAuth>
        }
      />
      <Route
        path="/analytics"
        element={
          <RequireAdminAuth>
            <AdminLayout>
              <AnalyticsPage />
            </AdminLayout>
          </RequireAdminAuth>
        }
      />
      <Route
        path="/user-outreach"
        element={
          <RequireAdminAuth>
            <AdminLayout>
              <UserOutreachPage />
            </AdminLayout>
          </RequireAdminAuth>
        }
      />
    </Routes>
  );
}
